const types = {
    ADD_EVENT: 'LIFECYCLE/ADD_EVENT',
    PICO_READY: 'LIFECYCLE/PICO_READY',
    MUTATORS_READY: 'LIFECYCLE/MUTATORS_READY',
    USER_REGISTERED: 'LIFECYCLE/USER_REGISTERED',
    USER_AUTHENTICATED: 'LIFECYCLE/USER_AUTHENTICATED',
    PAYMENT_METHOD_ADDED: 'LIFECYCLE/PAYMENT_METHOD_ADDED',
    PAYMENT_PAID: 'LIFECYCLE/PAYMENT_PAID',
    DIRECT_LINK_PROMPT: 'LIFECYCLE/DIRECT_LINK_PROMPT',
    PLAN_LINK_PROMPT: 'LIFECYCLE/PLAN_LINK_PROMPT',
    PICO_INIT: 'LIFECYCLE/PICO_INIT',
    MENU_PROMPT: 'LIFECYCLE/MENU_PROMPT',
    LAUNCHER_PROMPT: 'LIFECYCLE/LAUNCHER_PROMPT',
    POPUP_PROMPT: 'LIFECYCLE/POPUP_PROMPT',
    PICO_LOADED: 'LIFECYCLE/PICO_LOADED',
    USER_LOGOUT: 'LIFECYCLE/USER_LOGOUT',
}

const creators = {
    addEvent: ({ payload } = {}) => ({ type: types.ADD_EVENT, payload }),
    picoReady: () => ({ type: types.PICO_READY }),
    mutatorsReady: () => ({ type: types.MUTATORS_READY }),
    userRegistered: () => ({ type: types.USER_REGISTERED }),
    userAuthenticated: () => ({ type: types.USER_AUTHENTICATED }),
    paymentMethodAdded: () => ({ type: types.PAYMENT_METHOD_ADDED }),
    paymentPaid: () => ({ type: types.PAYMENT_PAID }),
    directLinkPrompt: ({ payload }) => ({ type: types.DIRECT_LINK_PROMPT, payload }),
    planLinkPrompt: ({ payload }) => ({ type: types.PLAN_LINK_PROMPT, payload }),
    picoInit: () => ({ type: types.PICO_INIT }),
    menuPrompt: () => ({ type: types.MENU_PROMPT }),
    launcherPrompt: ({ payload }) => ({ type: types.LAUNCHER_PROMPT, payload }),
    popupPrompt: ({ payload }) => ({ type: types.POPUP_PROMPT, payload }),
    picoLoaded: () => ({ type: types.PICO_LOADED }),
    userLogout: ({ payload }) => ({ type: types.USER_LOGOUT, payload }),
}

export {
    types,
    creators,
}
